import * as actionTypes from './reportActionTypes';
import axios from 'axios';
import config from "./../config/config";


export function getUserReport() {
  return function (dispatch) {
    return axios.get(config.api.server_url.request_url.base_url + "getAllUsersReport?individualReport=true", {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('token')
            }
        }).then((res) => {
        if(res.data){
                dispatch({ type: actionTypes.FETCH_USER_REPORT_SUCCESS, payload: res.data.data });
            }else{
                alert("something went wrong...");
                
            }
        }).catch(error => {
            alert(JSON.stringify(error.error));
            dispatch({type: actionTypes.FETCH_USER_REPORT_FAILURE, error: error});
        });
    };
}
